import React from 'react'
import PropTypes from 'prop-types'
import Paper from '@material-ui/core/Paper'
import { withStyles} from '@material-ui/core/styles'
import {
  Grid, Table, TableHeaderRow
} from '@devexpress/dx-react-grid-material-ui'

const styles = {
  customCell: {
    whiteSpace: "normal",
    wordWrap: "break-word"
  }
}

const CustomTableCellBase = ({ classes, ...restProps }) => (
  <Table.Cell className={classes.customCell} {...restProps} />
)

const CustomTableBase = ({ style, ...restProps }) => (
  <Table.Table
    style={{
      ...style,
      minWidth: 0
    }}
    {...restProps}
  />
)

const CustomTableCell = withStyles(styles)(CustomTableCellBase);
const CustomTable = withStyles(styles)(CustomTableBase);

class VideoOverlayTable extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      columns: [
        { name: "actionColumn", title: "Video Overlay Einstellungen" },
        { name: "descriptionColumn", title: "Beschreibung" }
      ],
      rows: [
        { actionColumn: 'Kameraname', descriptionColumn: 'Legen Sie hier den Namen fest, der Ihnen im Livevideo und im INSTAR Camera Tool angezeigt wird. Dieser wird in allen Endgeräten wie Ihrem Router und auch im Kameratool angezeigt.' },
        { actionColumn: 'Kamername einblenden', descriptionColumn: 'Anzeigen des Kameranamens im Livevideos.' },
        { actionColumn: 'Position (Kamername)', descriptionColumn: 'Wählen Sie die Position, an der der Kameraname angezeigt werden soll.' },
        { actionColumn: 'Zeitstempel einblenden', descriptionColumn: 'Sie können einen Zeitstempel im Format YYYY-MM-DD HH:MM:SS eiblenden lassen.' },
        { actionColumn: 'Position (Zeitstempel)', descriptionColumn: 'Wählen Sie die Position, an der der Zeitstempel angezeigt werden soll.' },
      ]
    };
  }
  render() {
    const { rows, columns } = this.state;

    return (
      <Paper style={{display: 'inline-block', maxWidth: '915px'}}>
        <Grid rows={rows} columns={columns}>
          <Table tableComponent={CustomTable} cellComponent={CustomTableCell} />
          <TableHeaderRow />
        </Grid>
      </Paper>
    );
  }
}

VideoOverlayTable.propTypes = {
  classes: PropTypes.object.isRequired,
}


export default withStyles(styles)(VideoOverlayTable)